
import {Component, Vue} from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {MapGetters} from "@/store/modules/auth/map-getters.auth";
import {VueEditor} from 'vue2-editor';
import {MapActionsSnackbar} from "@/store/modules/snackbar/map-actions.snackbar";
// Services
import SinalizacaoService from "@/service/sinalizacao.service";
import ContatoService from "@/service/contato.service";
// Utils
import RulesUtil from "@/util/rules";
import FormatUtil from "@/util/format.util";
// Models
import EnderecoModel from "@/models/cliente/endereco.model";
import ContatoModel from "@/models/cliente/contato.model";
import SinalizacaoResponse from "@/models/cliente/sinalizacao-response";
import Listas from "@/models/lists/listas.model";
import SinalizacaoModel from "@/models/cliente/sinalizacao.model";
import FileModel from "@/models/cliente/file-model";
// Components
import DatePickerComponent from "@/components/DatePickerComponent.vue";
import TimePickerComponent from "@/components/TimePickerComponent.vue";
import TitulosEmAbertoComponent from "@/components/TitulosEmAbertoComponent.vue";
import {MapActionsLoading} from "@/store/modules/loading/map-actions.loading";

const auth = namespace('auth');
const snackbar = namespace('snackbar');
const loading = namespace('loading');

@Component({
  name: "ClienteSinalizacao",
  components: {
    DatePickerComponent,
    TimePickerComponent,
    TitulosEmAbertoComponent,
    VueEditor
  }
})
export default class ClienteSinalizacao extends Vue {

  @auth.Getter(MapGetters.ID) idUsuarioLogado;
  @snackbar.Action(MapActionsSnackbar.SET_SNACKBAR_ERROR) setSnackbarError;
  @loading.Action(MapActionsLoading.OPEN_LOADING) openLoading;
  @loading.Action(MapActionsLoading.CLOSE_LOADING) closeLoading;

  private keyDataFim = 0;
  private keyDataInicio = 0;
  private response = new SinalizacaoResponse();
  private rules = RulesUtil;
  private listas = new Listas();
  private idCliente = 0;
  private idContatoDelete = 0;
  private dialogNewContato = false;
  private dialogDeleteContato = false;

  private file = null;
  private enderecoCompleto = "";
  private descricaoNovoContato = "";
  private tipoNovoContato = "";
  private novaSinalizacao = new SinalizacaoModel();
  private ultimaSinalizacao = new SinalizacaoModel();
  private files: Array<FileModel> = [];
  private keyDataAgendamento = 0;
  private dataAgendamento = "";
  private horaAgendamento: Record<string, any> = {date: '', time: ''};

  onChangeAgendamento() {
    this.dataAgendamento = '';
    this.keyDataAgendamento += 1;
    this.horaAgendamento = {date: '', time: ''};
    this.novaSinalizacao.agendamento_data_hora = null;
  }

  openModalDelete(idContato) {
    this.idContatoDelete = idContato;
    this.dialogDeleteContato = true;
  }

  async removerContato() {
    await ContatoService.delete(this.idContatoDelete);
    this.dialogDeleteContato = false;
    this.response.contatos = await ContatoService.buscarTodos(this.idCliente);
  }

  async salvarAnotacao() {
    if (this.novaSinalizacao.agendamento && (!this.dataAgendamento || !this.horaAgendamento.time)) {
      this.setSnackbarError('É necessário informar a data e hora para realizar um agendamento.');
    } else {
      if (this.novaSinalizacao.anotacoes) {
        this.novaSinalizacao.id_usuario = this.idUsuarioLogado;
        this.novaSinalizacao.id_entidade = this.idCliente;
        this.novaSinalizacao.agendamento_data_hora = this.formataHoraParaSalvar(this.horaAgendamento);
        await SinalizacaoService.salvarAnotacao(this.novaSinalizacao);
        this.response = await SinalizacaoService.getAll(this.idCliente);
        this.ultimaSinalizacao = this.response.itens[0];
        this.dataAgendamento = '';
        this.keyDataAgendamento += 1;
        this.horaAgendamento = {date: '', time: ''};
        this.novaSinalizacao = new SinalizacaoModel();
      } else {
        this.setSnackbarError('É necessário redigir a anotação antes de salvar.');
      }
    }
  }

  formataHoraParaSalvar(dateTime: Record<string, any>) {
    if (this.horaAgendamento.time) {
      return `${this.dataAgendamento} ${(dateTime as any).time.toString()}:00`;
    } else {
      return null;
    }
  }

  async inserirContato() {
    if ((this.$refs.formContato as HTMLFormElement).validate()) {
      let contato = new ContatoModel();
      contato.descricao = this.descricaoNovoContato;
      contato.tipo_contato = this.tipoNovoContato;
      contato.id_entidade = this.idCliente;
      await ContatoService.cadastrar(contato);
      this.dialogNewContato = false;
      this.response.contatos = await ContatoService.buscarTodos(this.idCliente);
      this.tipoNovoContato = "";
      this.descricaoNovoContato = "";
      (this.$refs.formContato as HTMLFormElement).reset();
    }
  }

  async adicionarAnexo() {
    if ((this.$refs.formAnexo as HTMLFormElement).validate()) {
      const formData = new FormData();
      const arquivo: any = this.file;
      formData.append('file', arquivo);
      await SinalizacaoService.salvarArquivo(formData, this.idCliente);
      this.file = null;
      (this.$refs.formAnexo as HTMLFormElement).reset();
      this.files = [];
      this.files = await SinalizacaoService.getAllArquivosClientes(this.idCliente);
    }
  }

  cancelar() {
    this.dialogNewContato = false;
    this.tipoNovoContato = "";
    this.descricaoNovoContato = "";
    (this.$refs.formContato as HTMLFormElement).reset();
  }

  montaEndereco(endereco: EnderecoModel) {
    const enderecoMontado = endereco.tipo_logradouro + " " +
        endereco.logradouro + ", " +
        endereco.numero + ", " +
        endereco.cidade + " - " +
        endereco.estado;
    this.enderecoCompleto = enderecoMontado.toUpperCase();
  }

  formataDateTimeVisualizacao(data: string) {
    if (data) {
      const [ano, mes, dia]: any = data.substring(0, 10).split("-");
      const horario: any = data.substring(10, 16);
      const dataFormatada = dia + "/" + mes + "/" + ano + " às " + horario;
      return dataFormatada;
    }
  }

  limpar() {
    this.keyDataInicio += 1;
    this.keyDataFim += 1;
  }

  async downloadArquivo(item: FileModel) {
    window.open(`${process.env.VUE_APP_API_BASE_URL}receptivo/download-file/${this.idCliente}/${item.fileName}`, '_blank');
  }

  async mounted() {
    this.openLoading();
    this.idCliente = parseInt(this.$route.params.id);
    this.response = await SinalizacaoService.getAll(this.idCliente);
    if (this.response) {
      this.files = await SinalizacaoService.getAllArquivosClientes(this.idCliente);
      this.response.cliente.cpf_cnpj = FormatUtil.cpfCnpj(this.response.cliente.cpf_cnpj);
      this.montaEndereco(this.response.endereco);
      if (this.response.itens[0]) {
        this.ultimaSinalizacao = this.response.itens[0];
      }
    }
    this.closeLoading();
  }

}
